import React from 'react'
import { useAuth0 } from '../../../../contexts/Auth0Context'
import LinkedInLogo from '../LinkedInLogo'

interface LinkedInCreateAccountProps {
  companyName: string
  isCompany: boolean | null
  isCurrentResident: boolean | null
}

const LinkedInCreateAccount = ({ companyName, isCompany, isCurrentResident }: LinkedInCreateAccountProps) => {
  const { loginWithRedirect } = useAuth0()
  const disableLinkedinSubmit = (isCompany && !companyName) || !isCurrentResident

  return (
    <>
      <span
        className={`${
          disableLinkedinSubmit && 'disabled-linkedin-button'
        } button button-is-outlined button-is-full_width linkedin-button`}
        onClick={() => !disableLinkedinSubmit && loginWithRedirect({ connection: 'linkedin', company_name: companyName })}
      >
        <LinkedInLogo />
        <span>Sign up with LinkedIn</span>
      </span>
      <div className="divider">
        <span className="divider-message">OR</span>
      </div>
    </>
  )
}

export default LinkedInCreateAccount
